var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddExpense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97832 0C5.87024 0.0255025 3.85566 0.876545 2.36492 2.37134C0.87417 3.86614 0.0254334 5.88619 0 8C0.0254334 10.1138 0.87417 12.1339 2.36492 13.6287C3.85566 15.1235 5.87024 15.9745 7.97832 16C10.0864 15.9745 12.101 15.1235 13.5917 13.6287C15.0825 12.1339 15.9312 10.1138 15.9566 8C15.9312 5.88619 15.0825 3.86614 13.5917 2.37134C12.101 0.876545 10.0864 0.0255025 7.97832 0ZM12.5374 8.57143H8.5482V12.5714H7.40844V8.57143H3.41928V7.42857H7.40844V3.42857H8.5482V7.42857H12.5374V8.57143Z",
    fill: "#FF4E77"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddExpense);
export default __webpack_public_path__ + "static/media/add-expense.88ce57e5829dd2e9f0078c7edde08a18.svg";
export { ForwardRef as ReactComponent };